import { StaticRouter } from 'react-router-dom/server'
import store from 'store'
import { ensureFreshAccessToken } from '@opallabs/api'
import { SimpleWorkspace } from '@opallabs/concepts'
import { Theme } from '@opallabs/gem'
import { DefaultQueryClientProvider } from '@opallabs/higgs'
import { ThemeProvider, WorkspaceContext } from '@opallabs/hooks'
import { PresenceSocketProvider } from '@opallabs/phoenix-websocket'
import { LiveViewers } from '..'

const RELAY_PRESENCE_URL = new URL('/relay/presence', window.location.origin)
RELAY_PRESENCE_URL.protocol = 'wss'

/**
 * The standard `LiveViewers` for the legacy monolith iframe.
 */
export const QueryableLiveViewers = ({
  entityType,
  entityId,
  workspace,
  theme = 'light',
}: {
  entityType: string
  entityId: string
  workspace: SimpleWorkspace
  theme?: Theme
}) => {
  const location = window.top?.location ?? window.location

  return (
    <DefaultQueryClientProvider>
      <StaticRouter location={location.pathname}>
        <ThemeProvider theme={theme}>
          <WorkspaceContext.Provider value={workspace}>
            <PresenceSocketProvider
              enabled
              url={RELAY_PRESENCE_URL.toString()}
              options={{
                authToken: store.get('accessToken'),
                refreshAuthToken: ensureFreshAccessToken,
              }}
            >
              <LiveViewers entityType={entityType} entityId={entityId} />
            </PresenceSocketProvider>
          </WorkspaceContext.Provider>
        </ThemeProvider>
      </StaticRouter>
    </DefaultQueryClientProvider>
  )
}
